
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop( { default: true } ) public Scroll: boolean;
        @Prop( { default: true } ) public Animar: boolean;
    }
